define('shared/util/tracking/clientIds',['$', 'shared/lib/RSVP', 'shared/lib/console'], function($, RSVP, console){

    'use strict';

    var CONSTANT = {
        GAClientId: 'GAClientId',
        AdobeVisitorId: 'AdobeVisitorId'
    };

    return {
        get: function(key){
            if(key === CONSTANT.GAClientId){
                var ga = window.ga;
                if(typeof(ga) !== 'function'){
                    console.warn('ga is not ready.');
                    return RSVP.resolve('');
                }

                return new RSVP.Promise(function(resolve){
                    ga(function(){
                        resolve(ga.getAll()[0].get('clientId'));
                    });
                });
            }
            else if(key === CONSTANT.AdobeVisitorId){
                var s = window.s;
                if(s && s.visitor && typeof(s.visitor.getAnalyticsVisitorID) === 'function'){
                    var analyticsVisitorId = s.visitor.getAnalyticsVisitorID();
                    if(analyticsVisitorId){
                        return RSVP.resolve(analyticsVisitorId);
                    }
                    else{
                        if(typeof(s.visitor.getMarketingCloudVisitorID) === 'function'){
                            return RSVP.resolve(s.visitor.getMarketingCloudVisitorID());
                        }
                        else{
                            console.warn('s.visitor.getMarketingCloudVisitorID is not ready.');
                            return RSVP.resolve('');
                        }
                    }
                }
                else{
                    console.warn('s is not ready.');
                    return RSVP.resolve('');
                }
            }
            else{
                return RSVP.reject('unrecognised key: ' + key);
            }
        },
        CONSTANT: CONSTANT
    };
});
